// extracted by mini-css-extract-plugin
module.exports = {"container":"User_container__2Dq7Y","greeting":"User_greeting__yN85H","fullName":"User_fullName__2GloE","text":"User_text__2cpD2"};